import { Button, Stack, Typography } from '@mui/material';
import React from 'react'
import FrmAgregarMovimiento from '../Forms/FrmAgregarMovimiento';
import Iconify from "../../../../components/Iconify";
const AddButtomMovimientosBanco = ({ setOpenDialog,
  setBodyDialog,
  setOpenSnackBar,
  setErrorGraph, 
id }) => {

  const handleOpenDialog = () => {
    setBodyDialog(<FrmAgregarMovimiento setOpenDialog={setOpenDialog}
      setErrorGraph={setErrorGraph}
      setOpenSnackBar={setOpenSnackBar}
      id={id} />)
    setOpenDialog(true);
  }
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant='h4' gutterBottom>Cuenta Bancaria: </Typography>
      <Button onClick={() => handleOpenDialog()} startIcon={<Iconify icon="eva:plus-fill" />}>Nuevo registro</Button>
    </Stack>
  );
}

export default AddButtomMovimientosBanco;